import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Checkbox, Box, Text } from "@chakra-ui/react";
import Layout from "../../../components/dashboard/Layout";
import InactiveStudentsTable from "../../../containers/admin/students/inactiveStudentsTable";
import SearchBar from "../../../containers/admin/students/searchbar";
import StudentReport from "../../../containers/admin/students/models/student-report";

const InactiveStudents = () => {
  const model = useSelector((state) => state.model.isOpen18);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [inactiveForOneWeek, setInactiveForOneWeek] = useState(false);

  return (
    <Layout>
      <SearchBar
        setSelectedData={setSelectedData}
        setSearchTerm={setSearchTerm}
      />

      <Box mb={4}>
        <Checkbox
          isChecked={inactiveForOneWeek}
          onChange={(e) => setInactiveForOneWeek(e.target.checked)}
        >
          <Text fontSize="sm" color="gray.600">
            Inactive For 1 Week
          </Text>
        </Checkbox>
      </Box>

      <InactiveStudentsTable
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
        inactiveForOneWeek={inactiveForOneWeek}
      />

      {model && (
        <StudentReport
          student_id={selectedData?.id}
          selectedData={selectedData}
        />
      )}
    </Layout>
  );
};

export default InactiveStudents;
